/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect } from 'react';
import { TextField, Button, IconButton } from '@mui/material';
import ModeEdit from '@mui/icons-material/ModeEdit';
import { useForm } from 'react-hook-form';
import { colors } from 'Constants/Colors';
import SideBarContainer from 'Containers/SideBarContainer';
import styles from './style';
import CustomLabel from '../../Utils/CustomLabel';
import useTranslation from '../../Hooks/useTranslation';
import Alert from '../../Components/Alert';
import { getEnterpriseInfo } from '../../Api/enterprisePage';
import enterpriseApi from '../../Api/axios/enterprise-api';

export default function Enterprise() {
  const { t2 } = useTranslation('Enterprise');
  const [isGrayedSubmit, setIsGrayedSubmit] = useState(true);
  const [enterpriseId, setEnterpriseId] = useState();
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [enterpriseInfo, setEnterpriseInfo] = useState(null);
  const textFieldStyles = styles.textFieldStyles();
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const setInfo = async () => {
    const response = await getEnterpriseInfo();
    if (!response || response.error) {
      return;
    }
    setEnterpriseInfo(response);
    setEnterpriseId(response.id);
  };

  const onSubmit = async data => {
    if (isGrayedSubmit) {
      return;
    }

    const response = await enterpriseApi.patch(enterpriseId, data);

    if (!response.error) {
      setOpenAlert(true);
      setAlertMessage(t2('EditSuccess'));
      setIsGrayedSubmit(true);
      await setInfo();
    }
  };

  const enableControls = () => {
    setIsGrayedSubmit(false);
    setValue('comercialName', enterpriseInfo.comercialName);
    setValue('legalName', enterpriseInfo.legalName);
    setValue('registerNumber', enterpriseInfo.registerNumber);
  };

  function EditButton() {
    return (
      <IconButton style={styles.editIconContainer} onClick={enableControls}>
        <ModeEdit style={styles.icon} />
      </IconButton>
    );
  }

  useEffect(() => {
    setInfo();
  }, []);

  const textField = fieldName => {
    const lowerCaseFieldName = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);

    const defaultEnterpriseInfo = {
      comercialName: enterpriseInfo?.comercialName,
      legalName: enterpriseInfo?.legalName,
      registerNumber: enterpriseInfo?.registerNumber,
    };

    const fieldErrors = {
      ComercialName: errors.comercialName?.type,
      LegalName: errors.legalName?.type,
      RegisterNumber: errors.registerNumber?.type,
    };

    const missingErrorMsg = t2(`Missing${fieldName}`);

    const invalidErrorMsg = t2(`Invalid${fieldName}`);

    return (
      <TextField
        defaultValue={defaultEnterpriseInfo[lowerCaseFieldName]}
        label={t2(fieldName)}
        style={styles.textField}
        color="MexlogGreen"
        className={isGrayedSubmit ? textFieldStyles.disabled : textFieldStyles.enabled}
        disabled={isGrayedSubmit}
        {...register(lowerCaseFieldName, {
          required: true,
          pattern: /^[a-zA-Z0-9]*$/,
        })}
        error={fieldErrors[fieldName] === 'required' || fieldErrors[fieldName] === 'pattern'}
        helperText={
          // eslint-disable-next-line no-nested-ternary
          fieldErrors[fieldName] === 'required'
            ? missingErrorMsg
            : fieldErrors[fieldName] === 'pattern'
              ? invalidErrorMsg
              : ''
        }
      />
    );
  };

  return (
    <SideBarContainer>
      <div style={styles.container} className="flex col">
        {isGrayedSubmit ? <EditButton /> : <div style={styles.emptyDiv} />}

        <CustomLabel type="h1" value={t2('Header')} style={styles.header} />
        <hr
          style={{
            width: '45%',
            backgroundColor: colors.GRAY_HR,
            height: '1px',
            border: '0px',
            marginBottom: '4rem',
          }}
        />
        {enterpriseInfo !== null ? (
          <form style={styles.form} onSubmit={handleSubmit(onSubmit)} autoComplete="false">
            {textField('ComercialName')}
            {textField('LegalName')}
            {textField('RegisterNumber')}
            <Button
              style={isGrayedSubmit ? styles.grayedSubmit : styles.enabledSubmit}
              type={isGrayedSubmit ? 'button' : 'submit'}
            >
              {t2('ButtonCaptionGrayed')}
            </Button>
          </form>
        ) : (
          <div>{t2('no_data')}</div>
        )}
      </div>
      <Alert message={alertMessage} open={openAlert} setOpen={setOpenAlert} />
    </SideBarContainer>
  );
}
